/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Receipt } from "../models";
import { getOverrideProps, useDataStoreBinding } from "./utils";
import ListedReceipt from "./ListedReceipt";
import { Collection } from "@aws-amplify/ui-react";
export default function ListedReceiptCollection(props) {
  const { items: itemsProp, overrideItems, overrides, ...rest } = props;
  const [items, setItems] = React.useState(undefined);
  const itemsDataStore = useDataStoreBinding({
    type: "collection",
    model: Receipt,
  }).items;
  React.useEffect(() => {
    if (itemsProp !== undefined) {
      setItems(itemsProp);
      return;
    }
    async function setItemsFromDataStore() {
      var loaded = await Promise.all(
        itemsDataStore.map(async (item) => ({
          ...item,
          items: await item.items.toArray(),
        }))
      );
      setItems(loaded);
    }
    setItemsFromDataStore();
  }, [itemsProp, itemsDataStore]);
  return (
    <Collection
      type="list"
      isSearchable="true"
      isPaginated={true}
      searchPlaceholder="Rehercher ..."
      itemsPerPage={50}
      direction="column"
      justifyContent="left"
      items={items || []}
      {...getOverrideProps(overrides, "ListedReceiptCollection")}
      {...rest}
    >
      {(item, index) => (
        <ListedReceipt
          receipt={item}
          key={item.id}
          {...(overrideItems && overrideItems({ item, index }))}
        ></ListedReceipt>
      )}
    </Collection>
  );
}
